import { ArrowLeft, MoreVertical, Trash } from '@/components/icons';
import { SaveIndicator, type SaveStatus } from '@/components/system/SaveIndicator';
import { Button } from '@/components/ui/button';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { getPatientInfoFields } from './patient-info';
import PatientContextBar from './PatientContextBar';
import type { Patient } from '@/types/patient';

type Props = {
    patient?: Patient;
    patientName?: string;
    status: SaveStatus;
    canDelete: boolean;
    onRetry: () => void;
    onBack: () => void;
    onDelete: () => void;
};

export default function AnamnesisHeader({
    patient,
    patientName,
    status,
    canDelete,
    onRetry,
    onBack,
    onDelete,
}: Props) {
    const hasContext = getPatientInfoFields(patient).length > 0;

    return (
        <header className="sticky top-0 z-20 -mx-4 -mt-4 mb-6 border-b border-border/70 bg-card/95 px-4 py-3 backdrop-blur supports-[backdrop-filter]:bg-card/80 sm:-mx-8 sm:-mt-8 sm:px-8 lg:-mx-10 lg:px-10">
            <div className="flex w-full items-center justify-between gap-3">
                <div className="flex min-w-0 items-center gap-3">
                    <Button
                        variant="ghost"
                        size="icon"
                        className="shrink-0"
                        onClick={onBack}
                        aria-label="Voltar"
                    >
                        <ArrowLeft className="size-4" />
                    </Button>
                    <div className="flex min-w-0 items-center gap-2">
                        <h1 className="truncate text-base font-semibold text-foreground">
                            {patientName ? `${patientName} · ` : ''}
                            <span className="text-muted-foreground">Anamnese</span>
                        </h1>
                    </div>
                </div>

                <div className="flex shrink-0 items-center gap-2">
                    <SaveIndicator status={status} onRetry={onRetry} />
                    {canDelete ? (
                        <DropdownMenu>
                            <DropdownMenuTrigger asChild>
                                <Button variant="ghost" size="icon" aria-label="Mais ações">
                                    <MoreVertical className="size-4" />
                                </Button>
                            </DropdownMenuTrigger>
                            <DropdownMenuContent align="end">
                                <DropdownMenuItem
                                    onSelect={onDelete}
                                    className="gap-2 text-destructive focus:bg-destructive/10 focus:text-destructive"
                                >
                                    <Trash className="size-4" />
                                    Excluir anamnese
                                </DropdownMenuItem>
                            </DropdownMenuContent>
                        </DropdownMenu>
                    ) : null}
                </div>
            </div>

            {hasContext && (
                <div className="mt-2.5 border-t border-border/50 pt-2.5">
                    <PatientContextBar patient={patient} />
                </div>
            )}
        </header>
    );
}
